import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var AVMEvent = /** @class */ (function (_super) {
    __extends(AVMEvent, _super);
    function AVMEvent(type, avmVersion) {
        var _this = _super.call(this, type) || this;
        _this._avmVersion = avmVersion;
        return _this;
    }
    Object.defineProperty(AVMEvent.prototype, "avmVersion", {
        /**
         * Additional human-readable message. Usually supplied for ParserEvent.PARSE_ERROR events.
         */
        get: function () {
            return this._avmVersion;
        },
        enumerable: true,
        configurable: true
    });
    AVMEvent.prototype.clone = function () {
        return new AVMEvent(this.type, this._avmVersion);
    };
    /**
     * Dispatched when a AVM has been init (should only happen once for each AVM)
     */
    AVMEvent.AVM_COMPLETE = 'avmComplete';
    return AVMEvent;
}(EventBase));
export { AVMEvent };
